import gql from 'graphql-tag';

import ThirdPartyOrgByIds from 'bundles/internal-enterprise/components/lead/queries/ThirdPartyOrgByIds.graphql';

export const userByEmailQuery = gql`
  query UserByEmailQuery($email: String!) {
    UsersV1Resource {
      email(email: $email) {
        elements {
          id
        }
      }
    }
  }
`;

export const thirdPartyOrganizationsQuery = ThirdPartyOrgByIds;

export const creditCardContractPriceQuery = gql`
  query CreditCardContractPriceQuery($seats: Int!) {
    EnterpriseSelfServeContractProductPricesV1Resource {
      getEnterpriseSelfServeContractProductPrice(userLimit: $seats, termInstallmentsTotal: 1) {
        elements {
          id
          amountTotal
        }
      }
    }
  }
`;
